import { useActiveFeatureFlags } from "@pharaday/feature-flag";

import useQueryAccessibleApps from "../apis/useQueryAccessibleApps";
import type { App } from "../core/domain/entities/app";
import { getAppFeatureFlag } from "../utils/get-app-feature-flag";

const useFilteredAppListByFeatureFlag = () => {
  const { data, isFetching } = useQueryAccessibleApps();
  const activeFeatureFlags = useActiveFeatureFlags();

  const handleFilterApp = (app: App) => {
    if (!activeFeatureFlags) {
      return true;
    }

    const appFeatureFlag = getAppFeatureFlag(app.type);
    if (!appFeatureFlag) {
      return true;
    }

    return activeFeatureFlags.includes(appFeatureFlag);
  };

  return {
    data: data?.filter(handleFilterApp),
    isFetching,
  };
};

export default useFilteredAppListByFeatureFlag;
